import React from 'react';
import { CheckCircle, XCircle, Search } from 'lucide-react';

interface IndexingMetricsCardProps {
  termsChecked: number;
  termsIndexed: number;
  termsNotIndexed: number;
}

const IndexingMetricsCard: React.FC<IndexingMetricsCardProps> = ({
  termsChecked,
  termsIndexed,
  termsNotIndexed
}) => {
  // Calculate percentages
  const indexedPercentage = termsChecked > 0 ? Math.round((termsIndexed / termsChecked) * 100) : 0;
  const notIndexedPercentage = termsChecked > 0 ? Math.round((termsNotIndexed / termsChecked) * 100) : 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {/* Terms Checked Card */}
      <div className="group bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-3 transition-all duration-300 hover:shadow-md hover:-translate-y-0.5 hover:border-blue-300 dark:hover:border-blue-600 hover:bg-gradient-to-r hover:from-blue-50 hover:to-blue-100 dark:hover:from-blue-900/20 dark:hover:to-blue-800/20 cursor-pointer">
        <div className="flex items-center justify-center space-x-2">
          <Search className="h-5 w-5 text-blue-600 dark:text-blue-400 group-hover:scale-110 transition-transform duration-300" />
          <div className="text-center">
            <div className="text-2xl font-bold text-blue-600 dark:text-blue-400 group-hover:scale-105 transition-transform duration-300">
              {termsChecked}
            </div>
            <div className="text-xs font-medium text-gray-500 dark:text-gray-400 group-hover:text-blue-700 dark:group-hover:text-blue-300 transition-colors duration-300">
              Terms Checked
            </div>
          </div>
        </div>
      </div>

      {/* Terms Indexed Card */}
      <div className="group bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-3 transition-all duration-300 hover:shadow-md hover:-translate-y-0.5 hover:border-green-300 dark:hover:border-green-600 hover:bg-gradient-to-r hover:from-green-50 hover:to-green-100 dark:hover:from-green-900/20 dark:hover:to-green-800/20 cursor-pointer">
        <div className="flex items-center justify-center space-x-2">
          <CheckCircle className="h-5 w-5 text-green-600 dark:text-green-400 group-hover:scale-110 transition-transform duration-300" />
          <div className="text-center">
            <div className="text-2xl font-bold text-green-600 dark:text-green-400 group-hover:scale-105 transition-transform duration-300">
              {termsIndexed}
            </div>
            <div className="text-xs font-medium text-gray-500 dark:text-gray-400 group-hover:text-green-700 dark:group-hover:text-green-300 transition-colors duration-300">
              Terms Indexed ({indexedPercentage}%)
            </div>
          </div>
        </div>
      </div>

      {/* Not Indexed Card */}
      <div className="group bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-3 transition-all duration-300 hover:shadow-md hover:-translate-y-0.5 hover:border-red-300 dark:hover:border-red-600 hover:bg-gradient-to-r hover:from-red-50 hover:to-red-100 dark:hover:from-red-900/20 dark:hover:to-red-800/20 cursor-pointer">
        <div className="flex items-center justify-center space-x-2">
          <XCircle className="h-5 w-5 text-red-600 dark:text-red-400 group-hover:scale-110 transition-transform duration-300" />
          <div className="text-center">
            <div className="text-2xl font-bold text-red-600 dark:text-red-400 group-hover:scale-105 transition-transform duration-300">
              {termsNotIndexed}
            </div>
            <div className="text-xs font-medium text-gray-500 dark:text-gray-400 group-hover:text-red-700 dark:group-hover:text-red-300 transition-colors duration-300">
              Not Indexed ({notIndexedPercentage}%)
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndexingMetricsCard;